import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';
import { Button, Icon } from '@pella/sash-framework';
import { Image } from '../../';

const CTA = ({ data, renderAs, children, className, icon, onClick, wide, ...other }) => {
	if (!data?.link?.href && !onClick) return null;

	const { link, asset_reference, gtm_link_text, gtm_link_type, target = '_self', ada_title, aria, button_style, material_icon, svg } = data;
	const linkCheckArray = ['http', 'www.', 'mailto:', '?', '#', 'tel:'];

	const renderContent = () => (
		<>
			{svg && <span dangerouslySetInnerHTML={{ __html: svg }} />}
			{(material_icon || icon) && <Icon name={material_icon || icon} />}
			{asset_reference && (
				<Image
					data={{ image: asset_reference }}
					className='mr-1'
				/>
			)}
			{(children || link?.title) && <span>{children || link?.title}</span>}
		</>
	);

	const renderButton = () => (
		<Button
			href={link?.href}
			color={button_style}
			data-gtm-linktype={gtm_link_type}
			data-gtm-linktext={gtm_link_text}
			target={target}
			title={ada_title}
			rel={target === '_blank' ? 'noopener noreferrer' : null}
			className={className || ''}
			aria-label={aria}
			onClick={onClick}
			passTo={!linkCheckArray.some((item) => link?.href?.includes(item)) && (target !== '_blank' || other?.component) ? true : false}
			component={!linkCheckArray.some((item) => link?.href?.includes(item)) && target !== '_blank' ? Link : other.component}
			wide={wide}
			{...other}
		>
			{renderContent()}
		</Button>
	);

	const renderTextLink = () => {
		if (target === '_blank' || linkCheckArray.some((item) => link?.href?.includes(item)) || onClick) {
			return (
				<a
					href={link?.href}
					data-gtm-linktype={gtm_link_type}
					data-gtm-linktext={gtm_link_text}
					target={target}
					rel={target === '_blank' ? 'noopener noreferrer' : null}
					title={ada_title || data.ada_link_title}
					aria-label={aria}
					className={className || ''}
					onClick={onClick}
					{...other}
				>
					{renderContent()}
				</a>
			);
		} else {
			return (
				<Link
					to={link?.href}
					data-gtm-linktype={gtm_link_type}
					data-gtm-linktext={gtm_link_text}
					title={ada_title || data.ada_link_title}
					aria-label={aria}
					className={className || ''}
					{...other}
				>
					{renderContent()}
				</Link>
			);
		}
	};

	return gtm_link_type !== 'button' || renderAs === 'link' ? renderTextLink() : renderButton();
};

CTA.propTypes = {
	data: PropTypes.object,
	children: PropTypes.node,
	className: PropTypes.string,
	icon: PropTypes.string,
	renderAs: PropTypes.string,
	onClick: PropTypes.func,
	wide: PropTypes.bool,
};

export default CTA;
